When the candidate profile was last updated in the partner system.

Expects a RFC 3339 compliant date time.
Millisecond precision is optional, and set to 0 if not provided.
